<template>
  <v-card outlined class="rounded-lg app-creation-object-section-card">
    <v-card-title class="primary--text pt-5 pb-0">
      <slot name="title" />
    </v-card-title>
    <v-card-text>
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'AppCreationObjectSectionCard',

}
</script>

<style>
.app-creation-object-section-card.v-sheet--outlined {
  border-color: #66359B !important;
}
</style>